import { useEffect, useMemo, useState } from "react";

import { FacetedSearch } from "@app/modules/results/helpers/faceted-search";
import { useResultsSelector } from "@app/modules/results/hooks/use-results-selector";
import { getFilters } from "@app/modules/results/selectors/state-accessors";

export const useFacetedSearch = () => {
  const faceted_search = useMemo(() => new FacetedSearch(), []);

  // Get all required data
  const filters = useResultsSelector(getFilters);

  // Force component updates when search results change
  const [, forceUpdate] = useState({});

  useEffect(() => {
    // Add callback to trigger re-render when search is performed
    faceted_search.onSearch(() => {
      forceUpdate({});
    });
  }, [faceted_search, filters]);

  return faceted_search;
};
